import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const babyFollowingUntil: BlogMetaData = {
  title: '後追いはいつまで続く？終わる時期の目安と乗り切り方【モンテッソーリ】',
  description:
    '後追いがいつまで続くのか不安な方へ。終わる時期の目安、落ち着き始めるサイン、しんどい時期を今日からラクに乗り切る関わり方をモンテッソーリの視点でやさしく解説します。',
  thumbnailUrl: '/img/blog-baby-following-until.webp',
  filePath: buildBlogFilePath('baby-following-until'),
  category: BLOG_CATEGORY.PARENTING,
};
